import { render } from "./AdminSurveyDetail.vue?vue&type=template&id=39688c6e&scoped=true"
import script from "./AdminSurveyDetail.vue?vue&type=script&lang=js"
export * from "./AdminSurveyDetail.vue?vue&type=script&lang=js"

import "./AdminSurveyDetail.vue?vue&type=style&index=0&id=39688c6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39688c6e"]])

export default __exports__